import axios from 'axios';
import { keyAccessToken, keyUserId } from '../../../../../assets/js/SessionStorageNames';

/**
 * 
 * @param {*} entId 
 * @param {*} currentPage 
 * @param {*} pageItemCount 
 * @param {*} filter 
 * @param {*} filterLinkedTo 
 * @param {*} currentBrand 
 * @param {*} filterStock 
 * @param {*} filterPrice 
 * @param {*} axiosCancelTokenSource 
 */
const getDataMl = (
    entId, currentPage, pageItemCount,
    filter, filterLinkedTo, currentBrand,
    filterStock, filterPrice, axiosCancelTokenSource,
    searchField = 'all'
) => {
    let filterQuery = {
        title: filter,
        barCode: filter,
        variBarCode: filter,
        sku: filter,
        variSku: filter,
    };

    if (searchField === 'title') {
        filterQuery = { title: filter };
    } else if (searchField === 'sku') {
        filterQuery = { sku: filter, variSku: filter };
    } else if (searchField === 'barcode') {
        filterQuery = { barCode: filter, variBarCode: filter };
    } else if (searchField === 'brand') {
        filterQuery = { brandSearch: filter };
    }

    const res = axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/ml-product/${entId}`,
        {
            params: {
                pageNumber: currentPage,
                pageItemCount: pageItemCount,
                filter: {
                    ...filterQuery,
                    filterLinkedTo,
                    brand: currentBrand,
                    skipVariants: true,
                    filterPrice,
                    filterStock,
                },
                checkIsFullyLinked: true,
                includeVariantData: true,
            },
            cancelToken: axiosCancelTokenSource.token,
            headers: {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": localStorage.getItem(
                    keyAccessToken
                ),
                "x-user-id": localStorage.getItem(keyUserId),
            },
        }
    )
    return res;
}

export default getDataMl;